import { render, staticRenderFns } from "./newsInspect.vue?vue&type=template&id=22469d82&scoped=true"
import script from "./newsInspect.vue?vue&type=script&lang=js"
export * from "./newsInspect.vue?vue&type=script&lang=js"
import style0 from "./newsInspect.vue?vue&type=style&index=0&id=22469d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22469d82",
  null
  
)

export default component.exports